export default (theme) => ({
    /** Same as QuickFilters `selectFuzzy` — padding on the fuzzy Select control */
    selectFuzzy: {
        '& [class*="inputWrapper"]': {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    root: {
        display: 'flex',
        flexFlow: 'column nowrap',
    },
    row: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        gap: 8,
        paddingBottom: 8,
    },
    divider: {
        marginTop: 8,
        marginBottom: 16,
    },
    sep: {
        display: 'inline-block',
        width: 10,
        textAlign: 'center',
    },
    badgeWrap: {
        width: 'calc(100% - 132px)',
    },
    inputWrap: {
        flexBasis: 80,
        '& [class*="inputWrapper"]': {
            padding: 0,
        },
    },
});
